import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? 0 : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于爱豆影视的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(faq.id)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                    {faq.question}
                  </h3>
                  <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${isOpen ? 'bg-primary-500/20 rotate-180' : 'bg-background-200'}`}>
                    <i className={`ri-arrow-down-s-line text-sm ${isOpen ? 'text-primary-400' : 'text-foreground-500'}`}></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}